import { render, staticRenderFns } from "./NotBookable.vue?vue&type=template&id=eb8c87b2&scoped=true"
import script from "./NotBookable.vue?vue&type=script&lang=js"
export * from "./NotBookable.vue?vue&type=script&lang=js"
import style0 from "./NotBookable.vue?vue&type=style&index=0&id=eb8c87b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8c87b2",
  null
  
)

export default component.exports